module.exports = __webpack_public_path__ + "images/kalaido535bf5c8f94b51da738208f98e442a24.png";